import { useMemo } from 'react'

const useVariableOptions = (variables, variableId) => {
  const variableOptions = useMemo(() => {
    const list = variables || []
    return list.map(variable => ({ value: variable.id, label: variable.name }))
  }, [variables])

  const selectedVariable = useMemo(() => {
    const match = variableOptions.find(option => String(option.value) === String(variableId))
    return match || null
  }, [variableOptions, variableId])

  return { variableOptions, selectedVariable }
}

export default useVariableOptions
